/* Galaxy - chat assist. Global, self-contained (injects its own CSS).
   Loaded from snippets/galaxy-header-motion.liquid. 2026-10-13.

   1. The Inbox chat host <shopify-chat> sits at z-index 2147483000, above every
      drawer. While the cart drawer, menu drawer, search or a quick-add modal is
      open the closed chat ball is hidden, so it never covers the checkout button
      or menu links. Dawn marks those states with body.overflow-hidden(-mobile/-tablet/
      -desktop). An open conversation (shopify-chat[open]) is never hidden.
   2. After 20s on a page the chat ball shakes and a small bubble pops out beside it:
      "Have a question? Ask us here." Click the bubble to open the chat, x to close; it
      goes by itself after 12s. Product pages: every product page. Other pages: once
      per browser session. Stops for the session once the visitor opens the chat or
      closes the bubble with x. Skipped while a drawer is open. Reduced-motion visitors
      get the bubble without the shake.
      The shake uses element.animate() on the launcher itself. A CSS animation on
      shopify-chat::part(activator) worked in Chrome but not in iPhone Safari (keyframes
      are not found across the shadow boundary there), so phones showed only the bubble.
      (Johnson 2026-10-13: no extra text or buttons on the product page, just the shake.
      Earlier versions with a "Chat with us" link, question chips and a nudge bubble
      were removed.) */
(function () {
  if (window.__gxChatAssist) return; window.__gxChatAssist = true;
  var WIGGLE_AFTER = 20000, OFF = 'gxChatNudgeOff', DONE = 'gxChatNudgedOnce';
  var isProduct = /^\/products\//.test(location.pathname);

  function flag(key, set) {
    try { if (set) { sessionStorage.setItem(key, '1'); return true; } return !!sessionStorage.getItem(key); } catch (e) { return false; }
  }
  function stopForSession() { flag(OFF, true); }
  function shouldRemind() {
    if (flag(OFF)) return false;
    return isProduct || !flag(DONE);
  }

  function css() {
    if (document.getElementById('gx-chat-assist-style')) return;
    var s = document.createElement('style'); s.id = 'gx-chat-assist-style';
    s.textContent =
        'body.overflow-hidden shopify-chat:not([open]),body.overflow-hidden-mobile shopify-chat:not([open]),'
      + 'body.overflow-hidden-tablet shopify-chat:not([open]),body.overflow-hidden-desktop shopify-chat:not([open]),'
      + 'body:has(cart-drawer.active) shopify-chat:not([open]){display:none !important;}'
      + 'body.overflow-hidden .gx-layer,body.overflow-hidden-mobile .gx-layer,body.overflow-hidden-tablet .gx-layer{display:none !important;}'
      + '.gx-nudge-layer{position:fixed;inset:0;pointer-events:none;z-index:2147482999;}'
      + '.gx-nudge{position:absolute;pointer-events:auto;max-width:min(240px,calc(100vw - 96px));padding:10px 32px 10px 14px;border-radius:14px;'
      + 'background:#fff;color:#1B2A78;font-size:14px;line-height:1.35;box-shadow:0 8px 28px rgba(15,23,60,.22);cursor:pointer;'
      + 'opacity:0;transform:translateX(8px) scale(.96);transform-origin:right center;transition:opacity .25s ease,transform .25s ease;}'
      + '.gx-nudge.is-on{opacity:1;transform:none;}'
      + '.gx-nudge:after{content:"";position:absolute;right:-6px;top:50%;width:12px;height:12px;margin-top:-6px;background:#fff;transform:rotate(45deg);}'
      + '.gx-nudge b{font-weight:600;}'
      + '.gx-nudge-x{position:absolute;top:3px;right:3px;width:26px;height:26px;border:0;background:none;color:#7a819e;'
      + 'font-size:18px;line-height:1;cursor:pointer;border-radius:50%;}'
      + '.gx-nudge-x:hover{background:#f1f3fa;color:#1B2A78;}'
      + 'body.overflow-hidden .gx-nudge-layer,body.overflow-hidden-mobile .gx-nudge-layer,body.overflow-hidden-tablet .gx-nudge-layer{display:none !important;}'
      + '@media print{.gx-nudge{display:none;}}';
    document.head.appendChild(s);
  }

  function blocked() {
    var host = document.querySelector('shopify-chat');
    if (!host || host.hasAttribute('open')) return true;
    if (document.body.className.indexOf('overflow-hidden') > -1) return true;
    return false;
  }

  /* The Inbox launcher button, inside nested open shadow roots. */
  function launcher() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var found = null;
    (function walk(root) {
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length && !found; i++) {
        if (all[i].getAttribute && all[i].getAttribute('part') === 'activator') { found = all[i]; return; }
        if (all[i].shadowRoot) walk(all[i].shadowRoot);
      }
    })(host.shadowRoot);
    return found;
  }

  var nudge = null;
  function hideNudge() {
    if (!nudge) return;
    var n = nudge; nudge = null;
    n.classList.remove('is-on');
    setTimeout(function () { var l = n.parentNode; if (l && l.parentNode) l.parentNode.removeChild(l); }, 300);
  }

  /* Same coordinate system as the chat ball: Inbox puts it in <shopify-chat> (fixed, inset:0)
     at CSS offsets on .activator-nudge. The bubble sits in its own fixed inset:0 layer at
     offsets worked out from those CSS numbers, never from on-screen measurements, so on
     phones it stays beside the ball while the browser toolbar moves. */
  function chatOffsets() {
    var a = launcher();
    if (!a || !a.parentElement) return null;
    var cs = getComputedStyle(a.parentElement);
    var b = parseFloat(cs.bottom), r = parseFloat(cs.right), ball = a.offsetHeight;
    if (isNaN(b) || isNaN(r) || !ball) return null;
    return { bottom: b, right: r, ball: ball };
  }

  function showNudge() {
    var o = chatOffsets();
    if (!o) return;
    var layer = document.createElement('div');
    layer.className = 'gx-nudge-layer';
    nudge = document.createElement('div');
    nudge.className = 'gx-nudge';
    nudge.setAttribute('role', 'status');
    nudge.innerHTML = '<b>Have a question?</b><br>Ask us here.'
      + '<button type="button" class="gx-nudge-x" aria-label="Dismiss">&times;</button>';
    layer.appendChild(nudge);
    document.body.appendChild(layer);
    nudge.style.right = Math.round(o.right + o.ball + 14) + 'px';
    nudge.style.bottom = Math.round(o.bottom + o.ball / 2 - nudge.offsetHeight / 2) + 'px';
    nudge.addEventListener('click', function (e) {
      stopForSession();
      if (e.target.closest('.gx-nudge-x')) { hideNudge(); return; }
      hideNudge();
      var host = document.querySelector('shopify-chat');
      if (host && !host.hasAttribute('open')) { var b = launcher(); if (b) b.click(); }
    });
    setTimeout(function () { if (nudge) nudge.classList.add('is-on'); }, 30);   /* not rAF: frozen in background tabs */
    setTimeout(hideNudge, 12000);
  }

  function shake() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var a = launcher();
    if (!a || !a.animate) return;
    try {
      a.animate([
        { transform: 'none' },
        { transform: 'rotate(-14deg) scale(1.08)', offset: 0.1 },
        { transform: 'rotate(12deg) scale(1.08)', offset: 0.2 },
        { transform: 'rotate(-10deg) scale(1.06)', offset: 0.3 },
        { transform: 'rotate(8deg) scale(1.04)', offset: 0.4 },
        { transform: 'rotate(-4deg)', offset: 0.5 },
        { transform: 'none', offset: 0.6 },
        { transform: 'none' }
      ], { duration: 1100, iterations: 2, easing: 'ease-in-out' });
    } catch (e) {}
  }

  function remind() {
    if (document.hidden) {                      /* tab in the background: wait until they come back */
      document.addEventListener('visibilitychange', function again() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', again);
        setTimeout(remind, 1500);
      });
      return;
    }
    if (!shouldRemind() || blocked()) return;
    flag(DONE, true);
    shake();
    showNudge();
  }

  function hook() {
    var host = document.querySelector('shopify-chat');
    if (!host || host.__gxHooked) return;
    host.__gxHooked = true;
    host.addEventListener('click', function () { stopForSession(); hideNudge(); });   /* opened it: no reminder needed */
  }

  function boot() {
    css();
    hook();
    if (shouldRemind()) setTimeout(remind, WIGGLE_AFTER);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', hook);
})();
